angular.module('components.caOrderTotals', [])
    .component('caOrderTotals', {
        templateUrl: 'main/order/orderdelivery/components/ordertotals.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            orderChangeCount: '<',
            order: '='
        },
        controller: controller
    });

// @ngInject
function controller($scope, $rootScope) {
    var vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    //Properties
    var grid = {};
    vm.orders = [];
    vm.currentUserClaims = $rootScope.currentUser.claims;
    vm.haveOrderArticlePurchaseCostClaim = haveOrderArticlePurchaseCostClaim();

    //Methods
    vm.captureGrid = captureGrid;
    vm.shouldShowFromLocation = shouldShowFromLocation;
    vm.shouldShowSupplier = shouldShowSupplier;
    vm.shouldShowDestination = shouldShowDestination;

    function onInit() {
        $scope.$watch(function() { return vm.orderChangeCount; }, function() {
            recalculateAggregatedData();
            refreshGrid();
        });
        vm.orders = [vm.order];
    }

    function onChanges() {
    }

    function onDestroy() {
    }

    function captureGrid(s) {
        grid = s;
    }

    function shouldShowSupplier() {
        return vm.order.orderType.orderSystemType === 'store' || vm.order.orderType.orderSystemType === 'automatic' || vm.order.orderType.orderSystemType === 'return';
    }
    function shouldShowFromLocation() {
        return vm.order.orderType.orderSystemType === 'internal' || vm.order.orderType.orderSystemType === 'automaticInternal' || vm.order.orderType.orderSystemType === 'return';
    }
    function shouldShowDestination() {
        return vm.order.orderType.orderSystemType !== 'return';
    }

    function haveOrderArticlePurchaseCostClaim(){
        if(vm.currentUserClaims.seepurchasecost === undefined){
           return false
        }

        if(!vm.currentUserClaims.seepurchasecost.read){
            return false
        }

        return true
    }

    function recalculateAggregatedData() {
        vm.order.summarizedPurchaseCost = 0;
        vm.order.summarizedSalesPrice = 0;
        vm.order.summarizedQuantity = 0;
        vm.order.summarizedDeliveredQuantity = 0;
        vm.order.deliveredValue = 0;

        _.forEach(vm.order.orderArticles, function(orderArticle) {
            _.forEach(orderArticle.orderRows, function(orderRow) {
                vm.order.summarizedPurchaseCost += orderRow.quantity * orderRow.purchaseCost;
                vm.order.summarizedSalesPrice += orderRow.articleVariant.salesPrice * orderRow.quantity;
                vm.order.summarizedQuantity += orderRow.quantity;
                _.forEach(orderRow.deliveryRows, function(deliveryRow) {
                    if (deliveryRow.systemStatus.toLowerCase() === 'delivered' && deliveryRow.deliveryRowType === 'deliveryIn') {
                         vm.order.summarizedDeliveredQuantity += deliveryRow.quantity;
                         vm.order.deliveredValue += deliveryRow.quantity * orderRow.purchaseCost;
                    }
                });
            });

        });
    }

    function refreshGrid() {
        if (grid.invalidate) {
            grid.invalidate();
        }
        if (grid.refresh) {
            grid.refresh();
        }
    }
}
